// 上面的搜索框的 placeholder 配置
export const inputPlaceholderOptions = {
  name: '调查员姓名',
  phone: '调查员手机号',
  taskName: '任务名称',
  taskState: '任务状态'
}

// 可以搜索的状态
export const taskStatusOptions = [
  {
    label: '已分配',
    value: 6
  },
  {
    label: '已关闭',
    value: 7
  },
  {
    label: '已结算',
    value: 8
  },
  {
    label: '邀请中',
    value: 9
  },
  {
    label: '已邀请',
    value: 10
  }
]

// 表格列的名字配置
export const tableColumnNameOptions = {
  name: '调查员',
  concat: '手机号',
  taskName: '任务名称',
  taskStatus: '任务状态',
  settleMethod: '结算类型',
  settleMode: '结算方式',
  expectedQuantity: '数量',
  unitPriceYuan: '单价',
  taskEndTime: '任务截止时间',
  // count: '答卷数量',
  // price: '答卷单价',
  commitCount: '提交数量',
  effectiveCount: '有效数量',
  switch: '任务开关',
  jobForm: '任务类型'
}

export const newFieldOptions = {
  taskName: 'executionName',
  endTime: 'executionValidateTo',
  count: 'executionQuantity',
  price: 'executionSingleAmount'
}
